import { chain, isNil } from 'lodash';
import { Injectable } from '@angular/core';
import { NavigationBehaviorOptions, Router } from '@angular/router';
import {
  PAGES_PATH,
  REQUEST_TRANSFER_MODULE,
} from '@app/shared/constants/routes';
import { lazyInject } from '@app/shared/decorators';
import { NavigateRule } from '@app/shared/types/common/common.type';

@Injectable()
export class NavigateService {
  @lazyInject(Router) public router: Router;

  public static getNavigateUrl(path: string): string {
    const DEFAULT_PATH: string = PAGES_PATH.SelectEvent;

    const purePath = chain(path).trimStart('#/').trimStart('/').value();

    // Define redirect rules
    // This defines the logic for configuring route redirection,
    // where the matching rules follow a "first match wins" priority.
    const rules: NavigateRule[] = [
      {
        module: REQUEST_TRANSFER_MODULE,
        matchFn: (pathStr: string) => /^transfer(\/.*)?$/.test(pathStr),
        navigateUrl: PAGES_PATH.RequestTransferList,
      },
    ];

    const matchedRule = rules.find((matcher) => matcher.matchFn(purePath));

    // If no rules match, redirect to the default path(select event page)
    return !isNil(matchedRule) ? matchedRule.navigateUrl : DEFAULT_PATH;
  }

  public navigateToPage(navigateBackUrl: string, toPage: string): void {
    this.router.navigateByUrl(toPage, {
      state: {
        navigateBackUrl,
      },
    });
  }

  public navigateToError(errorMessage: string): void {
    this.router.navigateByUrl('error', {
      state: {
        message: errorMessage,
      },
    });
  }

  public navigateToSignIn(options?: NavigationBehaviorOptions): void {
    this.router.navigateByUrl('sign-in', options);
  }

  public navigateToModuleHomePage(state: Record<string, any>): void {
    const navigateBackUrl = NavigateService.getNavigateUrl(
      state?.navigateBackUrl,
    );

    this.router.navigateByUrl(navigateBackUrl);
  }
}
